import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Form, Row, Col, Input, Select, Button } from 'antd'
import {withTranslation} from 'react-i18next'
const {TextArea} = Input
@inject('marketingShortLinkStore')
@observer
class FormModal extends Component {
  state = {
    shortLinkType: ''
  }

  formRef = React.createRef()

  componentDidMount() {
    const {marketingShortLinkStore, title} = this.props
    const {detailsObj} = marketingShortLinkStore
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        "marketingGroupId": detailsObj?.marketingGroupId,
        "type": detailsObj?.type,
        "shortLinkName": detailsObj?.shortLinkName,
        "sourceLinkUrl": detailsObj?.type==='1' ? detailsObj?.sourceLinkUrl : null,
        "appId": detailsObj?.type==='3' ? detailsObj?.appId : null,
        "appSecret": detailsObj?.type==='3' ? detailsObj?.appSecret : null,
        "appPath": detailsObj?.type==='3' ? detailsObj?.appPath : null
      })
      this.setState({
        shortLinkType: detailsObj?.type
      })
    }
  }

  handleOk = () => {
    const {marketingShortLinkStore, handleCancel, title} = this.props
    const {detailsObj} = marketingShortLinkStore
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        "id": title === 'edit' ? detailsObj?.id : null,
        "marketingGroupId": fieldsValue?.marketingGroupId,
        "type": fieldsValue?.type,
        "shortLinkName": fieldsValue?.shortLinkName,
        "sourceLinkUrl": fieldsValue?.type==='1' ? fieldsValue?.sourceLinkUrl : null,
        "appId": fieldsValue?.type==='3' ? fieldsValue?.appId : null,
        "appSecret": fieldsValue?.type==='3' ? fieldsValue?.appSecret : null,
        "appPath": fieldsValue?.type==='3' ? fieldsValue?.appPath : null
      }
      if (title === 'edit') {
        marketingShortLinkStore.onAddJobAction({...params, id: detailsObj.id}, title).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      } else {
        marketingShortLinkStore.onAddJobAction({...params}).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      }
    }).catch(() => {})
  }
  onChangeType = (e) => {
    this.setState({
      shortLinkType: e
    })
  }
  onChangeShortLinkName = (value) => {
    if(value.target.value===' ') {
      this.formRef.current.setFieldsValue({
        'shortLinkName': undefined,
      })
    }
    const val = value.target.value.replace(/\s/g, "")
    this.formRef.current.setFieldsValue({
      'shortLinkName': val,
    })
  }
  onChangeAppId = (value) => {
    if(value.target.value===' ') {
      this.formRef.current.setFieldsValue({
        'appId': undefined,
      })
    }
    const val = value.target.value.replace(/\s/g, "")
    this.formRef.current.setFieldsValue({
      'appId': val,
    })
  }
  onChangeAppSecret = (value) => {
    if(value.target.value===' ') {
      this.formRef.current.setFieldsValue({
        'appSecret': undefined,
      })
    }
    const val = value.target.value.replace(/\s/g, "")
    this.formRef.current.setFieldsValue({
      'appSecret': val,
    })
  }
  render() {
    const { marketingShortLinkStore, addModalVisible, handleCancel, title, t } = this.props
    const { groupList, typeList } = marketingShortLinkStore
    return (
      <>
        <Modal
          title={title === 'edit' ? t(`marketingManagement.editTitleShortLink`) : t(`marketingManagement.addTitleShortLink`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row gutter={[10, 10]}>
              <Col span={24}>
                <Form.Item name="marketingGroupId" label={t(`marketingManagement.marketingGroup`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.marketingGroup`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                    {groupList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.groupName}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="type" label={t(`marketingManagement.shortLinkType`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.shortLinkType`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeType} showSearch >
                    {typeList?.map(item => (<Select.Option key={item.code} value={item.code}>{item.name}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="shortLinkName" label={t(`marketingManagement.shortLinkName`)} rules={[{
                  required: true, message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.shortLinkName`)}`,
                }]} onChange={this.onChangeShortLinkName}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                </Form.Item>
              </Col>
              {this.state.shortLinkType === '1' ? <>
                <Col span={24} >
                  <Form.Item name='sourceLinkUrl' label={t(`marketingManagement.oldShortLink`)}
                              rules={[{ required: true, message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.oldShortLink`)}` }]}>
                    <TextArea rows={4} placeholder="请输入带http://或https://的网址" style={{width: '100%'}} />
                  </Form.Item>
                </Col>
              </> : this.state.shortLinkType === '3' ? <>
                <Col span={24}>
                  <Form.Item name="appId" label={t(`marketingManagement.smallProgramID`)} rules={[{
                    required: true,
                    message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.smallProgramID`)}`,
                  }]} onChange={this.onChangeAppId}>
                    <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="appSecret" label={t(`marketingManagement.smallProgramAppSecret`)} rules={[{
                    required: true,
                    message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.smallProgramAppSecret`)}`,
                  }]} onChange={this.onChangeAppSecret}>
                    <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                  </Form.Item>
                </Col>
                <Col span={24} >
                  <Form.Item name='appPath' label={t(`marketingManagement.smallProgramPath`)}
                              rules={[{ required: true, message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.smallProgramPath`)}`,pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                    <TextArea rows={4} placeholder="请输入小程序路径(例如：xxx/xxx/xxx(小程序路径) 或 xxx/xxx/xxx?type=xxx&id=xxx(带参数的小程序路径)" style={{width: '100%'}} />
                  </Form.Item>
                </Col>
              </> : null}
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
